import { MouseEvent } from 'react';

import Grid from '@mui/material/Grid';
import { map } from 'lodash-es';

import { ticketCardGridItemSx, ticketCardGridSize } from 'src/common/styles/ticketCardStyles';
import { IUser } from 'src/interfaces/User';

import UserCard from './UserCard';

interface Props {
  users: IUser[];
  canManage?: boolean;
  showViewParticipants?: boolean;
  onDelete: (id: string, e?: MouseEvent<unknown>) => void;
  onEdit: (id?: string, e?: MouseEvent<unknown>) => void;
}

export default function UsersGrid({
  users,
  canManage = false,
  showViewParticipants = false,
  onDelete,
  onEdit,
}: Props) {
  return (
    <Grid container spacing={2} sx={{ overflow: 'visible' }}>
      {map(users, user => (
        <Grid size={ticketCardGridSize} key={user.id} sx={ticketCardGridItemSx}>
          <UserCard
            user={user}
            canManage={canManage}
            showViewParticipants={showViewParticipants}
            onDelete={onDelete}
            onEdit={onEdit}
          />
        </Grid>
      ))}
    </Grid>
  );
}
